<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="show"
    @close="onChange"
    class="change-rate-modal"
    title
    width="480px"
  >
    <div slot="title">{{ $t('system::exchange-manager::change_rate') }}</div>

    <el-form :model="params" :rules="rules" class="type-body" label-width="0" ref="formType">
      <el-form-item label prop="value">
        <div class="exchange-info">
          1 {{ $t('system::exchange-manager::dollar') }} =
          <el-input-number
            :controls="false"
            :min="0"
            style="width: 180px;margin: 0 4px;text-align:left;"
            v-model.trim="params.value"
          ></el-input-number>
          {{ $t('system::exchange-manager::rmb') }}
        </div>
      </el-form-item>
    </el-form>

    <div class="dialog-footer" slot="footer">
      <el-button @click="onChange" >{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button
        :loading="loading"
        @click="onSave"
        type="primary"
      >{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { updateExchangeRate } from '@/server/system'
export default {
  name: 'change-rate-modal',

  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    drawRow: {
      default: () => {}
    }
  },
  watch: {
    visible (bool) {
      this.show = bool
      const data = this.drawRow
      this.params = {
        id: data.item.id,
        value: data.item.value,
        currencyCode:data.item.currencyCode
      }
      this.$nextTick(() => this.$refs.formType.clearValidate())
    },
    drawRow: {
      handler: function (data) {},
      deep: true
    }
  },
  data () {
    return {
      loading: false,
      rules: {
        value: [
          {
            required: true,
            message: `${this.$t('system::common::input_holder')}`,
            trigger: 'blur'
          }
        ]
      },
      show: false,
      params: {}
    }
  },
  mounted () {},
  methods: {
    onChange () {
      this.$emit('change', false)
    },
    onSave () {
      this.$refs['formType'].validate(async valid => {
        if (valid) {
          this.loading = true
          let params = {
          currencyCode: this.params.currencyCode,
          rate: this.params.value
        }
        if (this.params.id) {
          params.id = this.params.id
        }
        const { data } = await updateExchangeRate(params)
        if (data.code === this.$code) {
          this.$message.success(this.$t('system::tip::control_success'))
          this.$emit('save', this.drawRow)
          this.$emit('change', false)
        }
        this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.change-rate-modal {
  ::v-deep {
    .el-dialog__body {
      padding-left: 52px;
      padding-right: 52px;
    }
  }
  .exchange-info {
    ::v-deep {
      .el-input-number {
        input {
          text-align: left;
        }
      }
    }
  }

  .type-body {
    display: flex;
    justify-content: center;
    margin-top: 16px;
    align-items: center;
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
</style>
